import { io, Socket } from 'socket.io-client';
import { environment } from '../config/environment';

export class SocketService {
  private socket: Socket | null = null;

  setupSocketConnection() {
    this.socket = io(environment.SOCKET_URL, {
      query: {
        token: 'test-auth-token'
      }
    });
  }

  listen(eventName: string, callback: (data: any) => void) {
    if (this.socket) {
      this.socket.on(eventName, callback);
    }
  }

  emit(eventName: string, data: any) {
    if (this.socket) {
      this.socket.emit(eventName, data);
    }
  }

  removeListener(eventName: string) {
    if (this.socket) {
      this.socket.removeListener(eventName);
      this.socket.off(eventName);
    }
  }

  connectRoom(roomId: string) {
    if (this.socket) {
      this.socket.emit('room', roomId);
    }
  }

  disconnectRoom(roomId: string) {
    if (this.socket) {
      this.socket.emit('removeRoom', roomId);
    }
  }
}

export const socketService = new SocketService();

